import type { CoupleId, PersonId } from '@fs/zion-tree-types'

const getCoupleIdFromParentIds = (parent1Id: PersonId | undefined, parent2Id: PersonId | undefined): CoupleId =>
  `${parent1Id ?? 'UNKNOWN'}_${parent2Id ?? 'UNKNOWN'}`

export default getCoupleIdFromParentIds
